<template>
  <div class="product-info-nav-tab" :style="{right: appWidth ? `calc((${appWidth}px - 1120px) / 2)` : '', transform: `translate(${scrollRight}px, 0)`}">
    <div class="first-row">
      <div class="product-name">{{product.product_name}}</div>
      <div class="right-box">
        <button class="share-btn" v-if="product.status === 0" @click="shareProduct" v-display:create-visa-order>
          <div class="btn-title">分享给客户</div>
          <div class="btn-subtitle">由客户填写资料</div>
        </button>
        <button class="add-order-btn" v-if="product.status === 0" @click="addOrderNowInTop" v-display:create-visa-order>立即办理</button>
      </div>
    </div>
    <div class="info-nav">
      <div class="product-nav-tab" v-for="(map, index) in navSectionIdMaps"
        :key="index" :class="{ active: navSectionId === map.id }" @click="navToSection(map.id)">
        {{ map.text }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'product-info-nav-tab',
  props: {
    navSectionId: {
      type: String,
      default: '',
    },
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    navSectionIdMaps: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      appWidth: 0,
      scrollRight: 0, // 监听这些，都是为了低分辨率下出现横向滚动条所加的兼容处理
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {

    // 在顶部添加订单
    shareProduct() {
      this.$emit('shareProduct');
    },

    // 在顶部添加订单
    addOrderNowInTop() {
      this.$emit('addOrderCalled');
    },

    // 导航到特定区域
    navToSection(sectionId) {
      const target = this.navSectionIdMaps.find(map => map.id === sectionId).id;
      this.$emit('scroll-to-section', target);
    },
    handleResize() {
      if (document.querySelector('#app')) this.appWidth = document.querySelector('#app').offsetWidth;
    },
    handleScroll() {
      const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
      const scrollWidth = document.documentElement.scrollWidth || document.body.scrollWidth;
      const pageWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
      this.scrollRight = scrollWidth - pageWidth - scrollLeft;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/less/variable";

.product-info-nav-tab {
  position: fixed;
  top: 84px;
  right: calc(~'(100% - 1120px) / 2 ');
  width: 1120px;
  background-color: #fff;
  z-index: 15;
  box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.06);
  .first-row{
    padding: 14px 16px 10px 16px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E9EEF2;
    .product-name{
      flex-grow: 1;
      color: #2F333D;
      font-size: 22px;
      font-weight: 600;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .info-nav {
    height: 55px;
    display: flex;
    padding: 0 16px;
    .product-nav-tab {
      display: flex;
      align-items: center;
      position: relative;
      cursor: pointer;
      color: #5F666E;
      font-size: 14px;
      margin-right: 32px;
      &:last-child{
        margin-right: 0;
      }
      &.active {
        color: #599FFF;
        font-weight: 600;
        &::after{
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 32px;
          height: 3px;
          background: linear-gradient( 90deg, #1F88FF 0%, #8AC0FF 100%);
          border-radius: 2px 2px 0px 0px;
        }
      }
    }

  }

  .right-box{
    display: flex;
    align-items: center;
    .share-btn{
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      width:112px;
      height:40px;
      border-radius:2px;
      color: #FF8033;
      border: 1px solid #FF8033;
      font-size: 16px;
      line-height: 1;
      outline: none;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      .btn-subtitle{
        font-size: 10px;
        line-height: 14px;
        margin-top: 1px;
        letter-spacing: 1.6px;
      }
    }
    .add-order-btn {
      margin-left: 12px;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #FF8033;
      width:112px;
      height:40px;
      border-radius:2px;
      color: #fff;
      font-size: 16px;
      line-height: 1;
      border: none;
      outline: none;
      cursor: pointer;
    }
    .close-box{
      margin-left: 12px;
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      padding: 4px;
      cursor: pointer;
      .icon-close{
        width: 24px;
        height: 24px;
        background: url(../../../../assets/imgs/product-detail/icon-close.png) no-repeat center / 100% 100%;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/product-info-nav-tab.vue